import{css as t}from"styled-components";const o=function(o){return t`
  @supports not (aspect-ratio: auto) {
    &::before {
      float: left;
      padding-top: ${function(t){const[o,n]=t.replace(":","/").split("/").map((function(t){return parseInt(t.trim(),10)}));return`${(n/o*100).toFixed(2)}%`}(o)};
      content: '';
    }
    &::after {
      display: block;
      content: '';
      clear: both;
    }
  }
`};export{o as default};
